import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Persona } from "../../types"
import PersonaForm from "./PersonaForm"
import { useNavigate, useParams } from "react-router-dom"
import { usePersona, usePersonaDelete, usePersonaUpdate } from "../../hooks/persone"
import { Formik } from "formik"
import { initialValuesPersona, validationSchemaPersona } from "./PersonaCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function PersonaUpdate() {
  const updatePersona = usePersonaUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: persona } = usePersona(Number(id))

  const [modalStateDeletePersona, modalActionsDeletePersona] = useModalTrigger()

  const deletePersona = usePersonaDelete()

  const initialValues = useMemo(() => initialValuesPersona(persona), [persona])
  const validationSchema = useMemo(() => validationSchemaPersona(), [])

  useBreadcrumbs([{ label: "Persone", href: "/opere/persone" }, { label: "Dettaglio Persona" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{persona?.nome || <>&nbsp;</>}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeletePersona.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updatePersona.mutateAsync(values as Persona).then(() => {
                navigate(`/opere/persone`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6">
                  <PersonaForm />
                </Container>
                <BottomFormFixed url="/opere/persone" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeletePersona.isOpen}
        onClose={modalActionsDeletePersona.close}
        onDelete={() => {
          return deletePersona.mutateAsync(persona?.id).then(() => {
            navigate(`/opere/persone`)
          })
        }}
        message="Sei sicuro di voler eliminare questa persona?"
        title="Elimina persona"
      />
    </Layout>
  )
}
